import gql from 'graphql-tag';

export const updateMocEventAcknowledgement = gql`
  mutation updateMOCEventAcknowledgement(
    $id: String!
    $changes: MOCEventAckInput
  ) {
    updateMocEventAcknowledgement(id: $id, changes: $changes) {
      id
      Contact {
        id
        firstName
        lastName
      }
      acknowledged
      comments
      completedDt
      createdBy
      createdAt
      updater
      updatedAt
      deletedAt
      version
    }
  }
`;
